import React from 'react';
import aiImage from '../../assets/Latest-free-artificial-intelligence-for-image-making-4.jpg';

const AISection = () => {
    return (
        <section className="section">
            <div className='p-count'>
                <h2>هوش مصنوعی چیست؟</h2>
                <p className='p-section'>
                    هوش مصنوعی (AI) به عنوان یکی از پیشرفته‌ترین فناوری‌های عصر حاضر، به سیستم‌ها و نرم‌افزارها این امکان را می‌دهد که مانند انسان‌ها فکر کرده و تصمیم‌گیری کنند.
                </p>
                <img className='imag-seection' src={aiImage} alt="هوش مصنوعی" />
                <h2>معرفی دوره آموزش هوش مصنوعی</h2>
                <p className='p-section'>
                    این دوره آموزش هوش مصنوعی به‌صورت عملی جنبه‌های مختلف هوش مصنوعی را در قالب پروژه و به‌صورت عملی مورد بحث قرار می‌دهد.
                </p>
            </div>
        </section>
    );
};

export default AISection;